import { render, staticRenderFns } from "./TagHandler.vue?vue&type=template&id=b158118a"
import script from "./TagHandler.vue?vue&type=script&lang=js"
export * from "./TagHandler.vue?vue&type=script&lang=js"
import style0 from "./TagHandler.vue?vue&type=style&index=0&id=b158118a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports